var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAppLogoSilhouette = function SvgAppLogoSilhouette(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M257 330h510v285H257Zm206 118c0 25.41-20.59 46-46 46s-46-20.59-46-46 20.59-46 46-46 46 20.59 46 46Zm190 0c0 25.41-20.59 46-46 46s-46-20.59-46-46 20.59-46 46-46 46 20.59 46 46Zm-217 90c0 24.3 34.03 44 76 44s76-19.7 76-44Z",
    fill: "#FFF",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M257 615h510L512 795ZM251 225h522c18.78 0 34 15.22 34 34v52c0 18.78-15.22 34-34 34H251c-18.78 0-34-15.22-34-34v-52c0-18.78 15.22-34 34-34Z",
    fill: "#FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M432 233c0 57.99-47.01 105-105 105s-105-47.01-105-105 47.01-105 105-105 105 47.01 105 105Z",
    fill: "#FFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M647 194c0 74.56-60.44 135-135 135s-135-60.44-135-135S437.44 59 512 59s135 60.44 135 135Z",
    fill: "#FFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M792 236c0 55.23-44.77 100-100 100s-100-44.77-100-100 44.77-100 100-100 100 44.77 100 100Z",
    fill: "#FFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M697 330c15.46 0 28 12.54 28 28v84c0 15.46-12.54 28-28 28s-28-12.54-28-28v-84c0-15.46 12.54-28 28-28Z",
    fill: "#FFF"
  })));
};
export default SvgAppLogoSilhouette;